import { TextField, TextFieldProps } from "@justhome/react-ui";
import {
  Control,
  FieldPath,
  FieldValues,
  Path,
  PathValue,
  UseControllerProps,
  useController,
} from "react-hook-form";

const ControlledTextField = <T extends FieldValues>({
  control,
  suffix,
  disabled,
  name,
  rules,
  defaultValue,
  ...props
}: TextFieldProps & {
  name: FieldPath<T>;
  control: Control<T>;
  rules?: UseControllerProps<T>["rules"];
  defaultValue?: PathValue<T, Path<T>>;
}) => {
  const {
    field,
    fieldState: { isTouched, invalid, error },
    formState: { isSubmitted },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  const errorMessage = error?.message;
  const isInvalid = (isTouched || isSubmitted) && invalid;

  return (
    <TextField
      {...props}
      {...field}
      suffix={suffix}
      disabled={disabled}
      ref={field.ref}
      data-testid={field.name}
      errorMessage={isInvalid ? errorMessage : undefined}
    />
  );
};

export default ControlledTextField;
